import React from "react";
import './st.css';

export const StyledTitle = ({title}) => {
  return (
    <div>
      <h1 className="h1-tit">{title}</h1>
      <div className="styleDiv"></div>
    </div>
  )
}
